import EditSurveyPage from "../views/Surveys/EditSurvey"
import ViewSurveyPage from "../views/Surveys/ViewSurvey"


const surveyRoutes=[
    {
        path: '/edit',
        component: EditSurveyPage
    },
    {
      path:'/view',
      component:ViewSurveyPage
    }
]

export default surveyRoutes


// WEBPACK FOOTER //
// ./src/routes/survey.jsx